import { styled } from '@mui/material'
import { ActiveAudioWaves } from '$common/active-audio-waves'

export const TribuneActiveAudioWaves = styled(ActiveAudioWaves)`
  & span {
    background-color: ${({ theme }) => theme.palette.tribune500};
  }

  &[data-hasStroke='true'] {
    background: ${({ theme }) => theme.palette.tribuneGradientH};
  }
`
